import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { CollapseBlock } from '../../index.jsx';
import { FoBasicInformation } from '../FoBasicInformation.jsx';
import { useFoWorkshopBasicInformation } from '../../../../hooks/useFoWorkshopBasicInformation.jsx';

const WorkshopsDetail = ({
  workshop,
}) => {
  const { t } = useTranslation();
  const basicInformation = useFoWorkshopBasicInformation(workshop);

  return (
    <>
      <div style={{ margin: '10px' }}>
        <div className="detail-collapse">
          <CollapseBlock title={t('Základné informácie o seminári')}>
            <FoBasicInformation dataToRender={basicInformation} />
          </CollapseBlock>
        </div>
      </div>
    </>
  );
};

WorkshopsDetail.propTypes = {
  workshop: PropTypes.object.isRequired,
};

export default WorkshopsDetail;
